// extracted by mini-css-extract-plugin
module.exports = {"chip-list-container":"VIP_RMClusters__chip-list-container","chipListContainer":"VIP_RMClusters__chip-list-container"};